import Principal from "./modules/principal/Principal";

const App = () => { return <Principal /> };

export default App;
